<button pButton (click)="menu.show($event)" class="calendar-button" [ngClass]="[direction]">
  <fa-icon [icon]="faCalendar" />&nbsp;<span [attr.data-translate]="'calendar'">{{ 'calendar' | translate}}</span>
  <p-menu #menu [model]="calendarOptions">
    <ng-template pTemplate="item" let-item>
      @if (item.hasCustomAction) {
      <a pRipple (click)="customAction(item)"> <fa-icon [icon]="item.fontAwsemeIcon" />&nbsp;{{ item.platform }} </a>
      } @else {
      <a pRipple [href]="item.url" target="_blank" (click)="tracking(item)">
        <fa-icon [icon]="item.fontAwsemeIcon" />&nbsp;{{ item.platform }}
      </a>
      }
    </ng-template>
  </p-menu>
</button>